var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.getLoggedIn)?_c('timeout'):_vm._e(),_c('LayoutNav'),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }